<template>
    <div class="analytics">
        <!-- Yandex.Metrika counter -->
        <script type="application/javascript" >
        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        ym(76987660, "init", {
                clickmap:true,
                trackLinks:true,
                accurateTrackBounce:true,
                webvisor:true
        });
        </script>
        <noscript><div><img src="https://mc.yandex.ru/watch/76987660" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
        <!-- /Yandex.Metrika counter -->
        <!-- Global site tag (gtag.js) - Google Analytics -->
        <script type="application/javascript" async src="https://www.googletagmanager.com/gtag/js?id=G-SC1Z5PWSYH"></script>
        <script type="application/javascript">
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-SC1Z5PWSYH');
        </script>
    </div>
</template>

<script>
    export default {
        name: 'Analytics',
        components: {

        },
        computed: {

        },
        methods: {

        },
}
</script>

<style lang="scss" scoped>

</style>
